/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/root/information-modal/information-modal.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '@angular/core/src/linker/view_type';
import * as import6 from '@angular/core/src/change_detection/constants';
import * as import7 from '@angular/core/src/linker/component_factory';
import * as import8 from '../../../../../public/upgrade/root/information-modal/information-modal.service';
import * as import9 from '@ngx-translate/core/src/translate.pipe';
import * as import10 from '@angular/core/src/linker/view_container';
import * as import11 from '@angular/core/src/change_detection/change_detection_util';
import * as import12 from '@ngx-translate/core/src/translate.service';
import * as import13 from '../../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import14 from '@angular/core/src/linker/template_ref';
import * as import15 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import16 from '@angular/common/src/directives/ng_for';
import * as import17 from '@angular/core/src/security';
import * as import18 from '../../../../node_modules/@angular/common/src/directives/ng_class.ngfactory';
import * as import19 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import20 from '@angular/common/src/pipes/date_pipe';
import * as import21 from '@angular/core/src/change_detection/differs/keyvalue_differs';
import * as import22 from '@angular/core/src/linker/element_ref';
import * as import23 from '@angular/core/src/i18n/tokens';
import * as import24 from '@angular/common/src/directives/ng_class';
import * as import25 from '@angular/common/src/directives/ng_if';
export class Wrapper_InformationModalComponent {
  /*private*/ _eventHandler:Function;
  context:import0.InformationModalComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any) {
    this._changed = false;
    this.context = new import0.InformationModalComponent(p0);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_InformationModalComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_InformationModalComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.InformationModalComponent>;
  _InformationModalComponent_0_3:Wrapper_InformationModalComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_InformationModalComponent_Host0,renderType_InformationModalComponent_Host,import5.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'information-modal',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_InformationModalComponent0(this.viewUtils,this,0,this._el_0);
    this._InformationModalComponent_0_3 = new Wrapper_InformationModalComponent(this.injectorGet(import8.InformationModalService,this.parentIndex));
    this.compView_0.create(this._InformationModalComponent_0_3.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import7.ComponentRef_<any>(0,this,this._el_0,this._InformationModalComponent_0_3.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import0.InformationModalComponent) && (0 === requestNodeIndex))) { return this._InformationModalComponent_0_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._InformationModalComponent_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const InformationModalComponentNgFactory:import7.ComponentFactory<import0.InformationModalComponent> = new import7.ComponentFactory<import0.InformationModalComponent>('information-modal',View_InformationModalComponent_Host0,import0.InformationModalComponent);
const styles_InformationModalComponent:any[] = ([] as any[]);
class View_InformationModalComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import9.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_InformationModalComponent2,renderType_InformationModalComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import11.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this._pipe_translate_0 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import11.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.$implicit)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_InformationModalComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _vc_5:import10.ViewContainer;
  _TemplateRef_5_5:any;
  _NgFor_5_6:import13.Wrapper_NgFor;
  _text_6:any;
  /*private*/ _expr_10:any;
  _pipe_translate_0:import9.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_InformationModalComponent1,renderType_InformationModalComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_10 = import11.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'h5',new import3.InlineArray2(2,'class','modal-title eva-3-h5'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._vc_5 = new import10.ViewContainer(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import14.TemplateRef_(this,5,this._anchor_5);
    this._NgFor_5_6 = new import13.Wrapper_NgFor(this._vc_5.vcRef,this._TemplateRef_5_5,this.parentView.parentView.injectorGet(import15.IterableDiffers,this.parentView.parentIndex),this.parentView.ref);
    this._text_6 = this.renderer.createText(this._el_0,'\n        ',(null as any));
    this._pipe_translate_0 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6
    ]
    ),(null as any));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import16.NgFor) && (5 === requestNodeIndex))) { return this._NgFor_5_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import11.ValueUnwrapper();
    const currVal_5_0_0:any = ((this.context.$implicit == null)? (null as any): this.context.$implicit.texts);
    this._NgFor_5_6.check_ngForOf(currVal_5_0_0,throwOnChange,false);
    this._NgFor_5_6.ngDoCheck(this,this._anchor_5,throwOnChange);
    this._vc_5.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_10:any = import3.inlineInterpolate(1,' ',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.$implicit.subtitle)),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_10,currVal_10))) {
      this.renderer.setText(this._text_3,currVal_10);
      this._expr_10 = currVal_10;
    }
  }
  destroyInternal():void {
    this._vc_5.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 5)) { return new View_InformationModalComponent2(this.viewUtils,this,5,this._anchor_5,this._vc_5); }
    return (null as any);
  }
}
class View_InformationModalComponent3 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _expr_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import10.ViewContainer) {
    super(View_InformationModalComponent3,renderType_InformationModalComponent,import5.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_1 = import11.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'img',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_1:any = (('assets/logo-' + this.parentView.context.getInformationModal().getVcc().cardBrand) + '.png');
    if (import3.checkBinding(throwOnChange,this._expr_1,currVal_1)) {
      this.renderer.setElementProperty(this._el_0,'src',this.viewUtils.sanitizer.sanitize(import17.SecurityContext.URL,currVal_1));
      this._expr_1 = currVal_1;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
var renderType_InformationModalComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_InformationModalComponent,{});
export class View_InformationModalComponent0 extends import1.AppView<import0.InformationModalComponent> {
  _el_0:any;
  _NgClass_0_3:import18.Wrapper_NgClass;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _anchor_15:any;
  /*private*/ _vc_15:import10.ViewContainer;
  _TemplateRef_15_5:any;
  _NgFor_15_6:import13.Wrapper_NgFor;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _el_19:any;
  _NgClass_19_3:import18.Wrapper_NgClass;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _el_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _el_32:any;
  _text_33:any;
  _el_34:any;
  _text_35:any;
  _el_36:any;
  _text_37:any;
  _el_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _el_44:any;
  _el_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _text_51:any;
  _text_52:any;
  _el_53:any;
  _text_54:any;
  _el_55:any;
  _text_56:any;
  _text_57:any;
  _text_58:any;
  _text_59:any;
  _text_60:any;
  _el_61:any;
  _text_62:any;
  _el_63:any;
  _text_64:any;
  _el_65:any;
  _text_66:any;
  _el_67:any;
  _text_68:any;
  _text_69:any;
  _el_70:any;
  _text_71:any;
  _el_72:any;
  _text_73:any;
  _el_74:any;
  _text_75:any;
  _text_76:any;
  _text_77:any;
  _text_78:any;
  _text_79:any;
  _text_80:any;
  _text_81:any;
  _text_82:any;
  _el_83:any;
  _text_84:any;
  _el_85:any;
  _text_86:any;
  _el_87:any;
  _text_88:any;
  _el_89:any;
  _text_90:any;
  _el_91:any;
  _text_92:any;
  _el_93:any;
  _text_94:any;
  _el_95:any;
  _text_96:any;
  _el_97:any;
  _text_98:any;
  _el_99:any;
  _text_100:any;
  _el_101:any;
  _text_102:any;
  _text_103:any;
  _el_104:any;
  _text_105:any;
  _el_106:any;
  _text_107:any;
  _el_108:any;
  _text_109:any;
  _text_110:any;
  _el_111:any;
  _text_112:any;
  _text_113:any;
  _el_114:any;
  _text_115:any;
  _text_116:any;
  _el_117:any;
  _text_118:any;
  _text_119:any;
  _text_120:any;
  _el_121:any;
  _text_122:any;
  _el_123:any;
  _text_124:any;
  _el_125:any;
  _text_126:any;
  _el_127:any;
  _text_128:any;
  _text_129:any;
  _text_130:any;
  _el_131:any;
  _text_132:any;
  _el_133:any;
  _text_134:any;
  _text_135:any;
  _text_136:any;
  _text_137:any;
  _text_138:any;
  _text_139:any;
  _el_140:any;
  _text_141:any;
  _el_142:any;
  _text_143:any;
  _el_144:any;
  _text_145:any;
  _el_146:any;
  _text_147:any;
  _text_148:any;
  _text_149:any;
  _el_150:any;
  _text_151:any;
  _el_152:any;
  _text_153:any;
  _text_154:any;
  _text_155:any;
  _text_156:any;
  _text_157:any;
  _el_158:any;
  _text_159:any;
  _el_160:any;
  _text_161:any;
  _el_162:any;
  _text_163:any;
  _el_164:any;
  _text_165:any;
  _el_166:any;
  _text_167:any;
  _text_168:any;
  _el_169:any;
  _el_170:any;
  _text_171:any;
  _text_172:any;
  _text_173:any;
  _el_174:any;
  _text_175:any;
  _el_176:any;
  _text_177:any;
  _text_178:any;
  _el_179:any;
  _el_180:any;
  _text_181:any;
  _text_182:any;
  _text_183:any;
  _el_184:any;
  _text_185:any;
  _el_186:any;
  _text_187:any;
  _text_188:any;
  _el_189:any;
  _el_190:any;
  _text_191:any;
  _text_192:any;
  _text_193:any;
  _el_194:any;
  _text_195:any;
  _el_196:any;
  _text_197:any;
  _text_198:any;
  _el_199:any;
  _el_200:any;
  _text_201:any;
  _text_202:any;
  _text_203:any;
  _text_204:any;
  _el_205:any;
  _text_206:any;
  _el_207:any;
  _text_208:any;
  _el_209:any;
  _text_210:any;
  _el_211:any;
  _text_212:any;
  _text_213:any;
  _text_214:any;
  _text_215:any;
  _text_216:any;
  _text_217:any;
  _el_218:any;
  _text_219:any;
  _el_220:any;
  _text_221:any;
  _anchor_222:any;
  /*private*/ _vc_222:import10.ViewContainer;
  _TemplateRef_222_5:any;
  _NgIf_222_6:import19.Wrapper_NgIf;
  _text_223:any;
  _text_224:any;
  _el_225:any;
  _text_226:any;
  _el_227:any;
  _text_228:any;
  _text_229:any;
  _text_230:any;
  _text_231:any;
  _text_232:any;
  _text_233:any;
  _text_234:any;
  _text_235:any;
  _text_236:any;
  _text_237:any;
  _text_238:any;
  _text_239:any;
  _map_248:any;
  /*private*/ _expr_249:any;
  _pipe_translate_0:import9.TranslatePipe;
  _map_251:any;
  /*private*/ _expr_252:any;
  _pipe_translate_1:import9.TranslatePipe;
  /*private*/ _expr_254:any;
  /*private*/ _expr_255:any;
  _pipe_translate_2:import9.TranslatePipe;
  /*private*/ _expr_257:any;
  _pipe_translate_3:import9.TranslatePipe;
  _pipe_date_4:import20.DatePipe;
  _pipe_date_4_0:any;
  /*private*/ _expr_261:any;
  /*private*/ _expr_262:any;
  _pipe_translate_5:import9.TranslatePipe;
  /*private*/ _expr_264:any;
  _pipe_translate_6:import9.TranslatePipe;
  /*private*/ _expr_266:any;
  /*private*/ _expr_267:any;
  /*private*/ _expr_268:any;
  /*private*/ _expr_269:any;
  /*private*/ _expr_270:any;
  /*private*/ _expr_271:any;
  _pipe_translate_7:import9.TranslatePipe;
  /*private*/ _expr_273:any;
  /*private*/ _expr_274:any;
  _pipe_translate_8:import9.TranslatePipe;
  /*private*/ _expr_276:any;
  /*private*/ _expr_277:any;
  _pipe_translate_9:import9.TranslatePipe;
  /*private*/ _expr_279:any;
  /*private*/ _expr_280:any;
  _pipe_translate_10:import9.TranslatePipe;
  /*private*/ _expr_282:any;
  /*private*/ _expr_283:any;
  _pipe_translate_11:import9.TranslatePipe;
  /*private*/ _expr_285:any;
  /*private*/ _expr_286:any;
  /*private*/ _expr_287:any;
  /*private*/ _expr_288:any;
  /*private*/ _expr_289:any;
  /*private*/ _expr_290:any;
  /*private*/ _expr_291:any;
  _pipe_translate_12:import9.TranslatePipe;
  /*private*/ _expr_293:any;
  /*private*/ _expr_294:any;
  _pipe_translate_13:import9.TranslatePipe;
  /*private*/ _expr_296:any;
  /*private*/ _expr_297:any;
  _pipe_translate_14:import9.TranslatePipe;
  /*private*/ _expr_299:any;
  /*private*/ _expr_300:any;
  _pipe_translate_15:import9.TranslatePipe;
  /*private*/ _expr_302:any;
  /*private*/ _expr_303:any;
  /*private*/ _expr_304:any;
  _pipe_translate_16:import9.TranslatePipe;
  /*private*/ _expr_306:any;
  _pipe_translate_17:import9.TranslatePipe;
  /*private*/ _expr_308:any;
  /*private*/ _expr_309:any;
  /*private*/ _expr_310:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_InformationModalComponent0,renderType_InformationModalComponent,import5.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import6.ChangeDetectorStatus.CheckAlways);
    this._map_248 = import3.pureProxy1((p0:any):{[key: string]:any} => {
      return {'-show-modal': p0};
    });
    this._expr_249 = import11.UNINITIALIZED;
    this._map_251 = import3.pureProxy3((p0:any,p1:any,p2:any):{[key: string]:any} => {
      return {
        '-show-modal': p0,
        'vcc-pending': p1,
        'vcc-active': p2
      }
      ;
    });
    this._expr_252 = import11.UNINITIALIZED;
    this._expr_254 = import11.UNINITIALIZED;
    this._expr_255 = import11.UNINITIALIZED;
    this._expr_257 = import11.UNINITIALIZED;
    this._expr_261 = import11.UNINITIALIZED;
    this._expr_262 = import11.UNINITIALIZED;
    this._expr_264 = import11.UNINITIALIZED;
    this._expr_266 = import11.UNINITIALIZED;
    this._expr_267 = import11.UNINITIALIZED;
    this._expr_268 = import11.UNINITIALIZED;
    this._expr_269 = import11.UNINITIALIZED;
    this._expr_270 = import11.UNINITIALIZED;
    this._expr_271 = import11.UNINITIALIZED;
    this._expr_273 = import11.UNINITIALIZED;
    this._expr_274 = import11.UNINITIALIZED;
    this._expr_276 = import11.UNINITIALIZED;
    this._expr_277 = import11.UNINITIALIZED;
    this._expr_279 = import11.UNINITIALIZED;
    this._expr_280 = import11.UNINITIALIZED;
    this._expr_282 = import11.UNINITIALIZED;
    this._expr_283 = import11.UNINITIALIZED;
    this._expr_285 = import11.UNINITIALIZED;
    this._expr_286 = import11.UNINITIALIZED;
    this._expr_287 = import11.UNINITIALIZED;
    this._expr_288 = import11.UNINITIALIZED;
    this._expr_289 = import11.UNINITIALIZED;
    this._expr_290 = import11.UNINITIALIZED;
    this._expr_291 = import11.UNINITIALIZED;
    this._expr_293 = import11.UNINITIALIZED;
    this._expr_294 = import11.UNINITIALIZED;
    this._expr_296 = import11.UNINITIALIZED;
    this._expr_297 = import11.UNINITIALIZED;
    this._expr_299 = import11.UNINITIALIZED;
    this._expr_300 = import11.UNINITIALIZED;
    this._expr_302 = import11.UNINITIALIZED;
    this._expr_303 = import11.UNINITIALIZED;
    this._expr_304 = import11.UNINITIALIZED;
    this._expr_306 = import11.UNINITIALIZED;
    this._expr_308 = import11.UNINITIALIZED;
    this._expr_309 = import11.UNINITIALIZED;
    this._expr_310 = import11.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import7.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray4(4,'class','eva-3-modal','style','z-index: 10'),(null as any));
    this._NgClass_0_3 = new import18.Wrapper_NgClass(this.parentView.injectorGet(import15.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import21.KeyValueDiffers,this.parentIndex),new import22.ElementRef(this._el_0),this.renderer);
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','modal-header'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'i',new import3.InlineArray2(2,'class','modal-close eva-3-icon-close'),(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_2,'div',new import3.InlineArray2(2,'class','modal-title-container'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'h4',new import3.InlineArray2(2,'class','modal-title eva-3-h4'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n        ',(null as any));
    this._text_11 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_12 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_13 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','modal-content eva-modal-container'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._anchor_15 = this.renderer.createTemplateAnchor(this._el_13,(null as any));
    this._vc_15 = new import10.ViewContainer(15,13,this,this._anchor_15);
    this._TemplateRef_15_5 = new import14.TemplateRef_(this,15,this._anchor_15);
    this._NgFor_15_6 = new import13.Wrapper_NgFor(this._vc_15.vcRef,this._TemplateRef_15_5,this.parentView.injectorGet(import15.IterableDiffers,this.parentIndex),this.ref);
    this._text_16 = this.renderer.createText(this._el_13,'\n    ',(null as any));
    this._text_17 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_18 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray4(4,'class','eva-3-modal vcc','style','z-index: 10'),(null as any));
    this._NgClass_19_3 = new import18.Wrapper_NgClass(this.parentView.injectorGet(import15.IterableDiffers,this.parentIndex),this.parentView.injectorGet(import21.KeyValueDiffers,this.parentIndex),new import22.ElementRef(this._el_19),this.renderer);
    this._text_20 = this.renderer.createText(this._el_19,'\n    ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_19,'div',new import3.InlineArray2(2,'class','modal-header'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n        ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'i',new import3.InlineArray2(2,'class','modal-close eva-3-icon-close'),(null as any));
    this._text_24 = this.renderer.createText(this._el_21,'\n        ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_21,'div',new import3.InlineArray2(2,'class','modal-title-container'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'\n            ',(null as any));
    this._el_27 = import3.createRenderElement(this.renderer,this._el_25,'h4',new import3.InlineArray2(2,'class','modal-title eva-3-h4'),(null as any));
    this._text_28 = this.renderer.createText(this._el_27,'',(null as any));
    this._text_29 = this.renderer.createText(this._el_25,'\n        ',(null as any));
    this._text_30 = this.renderer.createText(this._el_21,'\n    ',(null as any));
    this._text_31 = this.renderer.createText(this._el_19,'\n    ',(null as any));
    this._el_32 = import3.createRenderElement(this.renderer,this._el_19,'div',new import3.InlineArray2(2,'class','modal-content eva-modal-container'),(null as any));
    this._text_33 = this.renderer.createText(this._el_32,'\n        ',(null as any));
    this._el_34 = import3.createRenderElement(this.renderer,this._el_32,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md modal-border-bottom'),(null as any));
    this._text_35 = this.renderer.createText(this._el_34,'\n            ',(null as any));
    this._el_36 = import3.createRenderElement(this.renderer,this._el_34,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_37 = this.renderer.createText(this._el_36,'\n                ',(null as any));
    this._el_38 = import3.createRenderElement(this.renderer,this._el_36,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_39 = this.renderer.createText(this._el_38,'\n                    ',(null as any));
    this._el_40 = import3.createRenderElement(this.renderer,this._el_38,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'\n                        ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_40,'div',new import3.InlineArray2(2,'class','eva-3-message -info'),(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'\n                            ',(null as any));
    this._el_44 = import3.createRenderElement(this.renderer,this._el_42,'div',new import3.InlineArray2(2,'class','message-icon-container fix-message-icon'),(null as any));
    this._el_45 = import3.createRenderElement(this.renderer,this._el_44,'i',new import3.InlineArray2(2,'class','message-icon eva-3-icon-info-circle'),(null as any));
    this._text_46 = this.renderer.createText(this._el_42,'\n                            ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_42,'div',new import3.InlineArray2(2,'class','message-header'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                                ',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_47,'h5',new import3.InlineArray2(2,'class','eva-3-h5 message-title'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'',(null as any));
    this._text_51 = this.renderer.createText(this._el_47,'\n                            ',(null as any));
    this._text_52 = this.renderer.createText(this._el_42,'\n                            ',(null as any));
    this._el_53 = import3.createRenderElement(this.renderer,this._el_42,'div',new import3.InlineArray2(2,'class','message-body'),(null as any));
    this._text_54 = this.renderer.createText(this._el_53,'\n                                ',(null as any));
    this._el_55 = import3.createRenderElement(this.renderer,this._el_53,'p',new import3.InlineArray2(2,'class','eva-3-p message-text'),(null as any));
    this._text_56 = this.renderer.createText(this._el_55,'',(null as any));
    this._text_57 = this.renderer.createText(this._el_53,'\n                            ',(null as any));
    this._text_58 = this.renderer.createText(this._el_42,'\n                        ',(null as any));
    this._text_59 = this.renderer.createText(this._el_40,'\n                    ',(null as any));
    this._text_60 = this.renderer.createText(this._el_38,'\n                    ',(null as any));
    this._el_61 = import3.createRenderElement(this.renderer,this._el_38,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_62 = this.renderer.createText(this._el_61,'\n                        ',(null as any));
    this._el_63 = import3.createRenderElement(this.renderer,this._el_61,'div',new import3.InlineArray2(2,'class','eva-3-message -error -no-title'),(null as any));
    this._text_64 = this.renderer.createText(this._el_63,'\n                            ',(null as any));
    this._el_65 = import3.createRenderElement(this.renderer,this._el_63,'div',new import3.InlineArray2(2,'class','message-icon-container fix-message-icon'),(null as any));
    this._text_66 = this.renderer.createText(this._el_65,'\n                                ',(null as any));
    this._el_67 = import3.createRenderElement(this.renderer,this._el_65,'i',new import3.InlineArray2(2,'class','message-icon eva-3-icon-error-circle'),(null as any));
    this._text_68 = this.renderer.createText(this._el_65,'\n                            ',(null as any));
    this._text_69 = this.renderer.createText(this._el_63,'\n                            ',(null as any));
    this._el_70 = import3.createRenderElement(this.renderer,this._el_63,'div',new import3.InlineArray2(2,'class','message-body'),(null as any));
    this._text_71 = this.renderer.createText(this._el_70,'\n                                ',(null as any));
    this._el_72 = import3.createRenderElement(this.renderer,this._el_70,'p',new import3.InlineArray2(2,'class','eva-3-p message-text'),(null as any));
    this._text_73 = this.renderer.createText(this._el_72,'',(null as any));
    this._el_74 = import3.createRenderElement(this.renderer,this._el_72,'a',new import3.InlineArray4(4,'class','eva-3-link message-link','href','mailto:ast@despegar.com'),(null as any));
    this._text_75 = this.renderer.createText(this._el_74,'',(null as any));
    this._text_76 = this.renderer.createText(this._el_72,'.',(null as any));
    this._text_77 = this.renderer.createText(this._el_70,'\n                            ',(null as any));
    this._text_78 = this.renderer.createText(this._el_63,'\n                        ',(null as any));
    this._text_79 = this.renderer.createText(this._el_61,'\n                    ',(null as any));
    this._text_80 = this.renderer.createText(this._el_38,'\n                ',(null as any));
    this._text_81 = this.renderer.createText(this._el_36,'\n            ',(null as any));
    this._text_82 = this.renderer.createText(this._el_34,'\n            ',(null as any));
    this._el_83 = import3.createRenderElement(this.renderer,this._el_34,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_84 = this.renderer.createText(this._el_83,'\n                ',(null as any));
    this._el_85 = import3.createRenderElement(this.renderer,this._el_83,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_86 = this.renderer.createText(this._el_85,'\n                    ',(null as any));
    this._el_87 = import3.createRenderElement(this.renderer,this._el_85,'div',new import3.InlineArray2(2,'class','vcc-content'),(null as any));
    this._text_88 = this.renderer.createText(this._el_87,'\n                        ',(null as any));
    this._el_89 = import3.createRenderElement(this.renderer,this._el_87,'div',new import3.InlineArray2(2,'class','vcc-background'),(null as any));
    this._text_90 = this.renderer.createText(this._el_89,'\n                            ',(null as any));
    this._el_91 = import3.createRenderElement(this.renderer,this._el_89,'div',new import3.InlineArray2(2,'class','vcc-data'),(null as any));
    this._text_92 = this.renderer.createText(this._el_91,'\n                                ',(null as any));
    this._el_93 = import3.createRenderElement(this.renderer,this._el_91,'div',new import3.InlineArray2(2,'class','vcc-header-container'),(null as any));
    this._text_94 = this.renderer.createText(this._el_93,'\n                                    ',(null as any));
    this._el_95 = import3.createRenderElement(this.renderer,this._el_93,'div',new import3.InlineArray2(2,'class','vcc-icon'),(null as any));
    this._text_96 = this.renderer.createText(this._el_95,'\n                                        ',(null as any));
    this._el_97 = import3.createRenderElement(this.renderer,this._el_95,'i',new import3.InlineArray2(2,'class','eva-3-icon-checkmark-circle -eva-3-icon-md -eva-3-tc-green-3'),(null as any));
    this._text_98 = this.renderer.createText(this._el_95,'\n                                        ',(null as any));
    this._el_99 = import3.createRenderElement(this.renderer,this._el_95,'i',new import3.InlineArray2(2,'class','eva-3-icon-warning -eva-3-icon-md -eva-3-tc-blue-3'),(null as any));
    this._text_100 = this.renderer.createText(this._el_95,'\n                                        ',(null as any));
    this._el_101 = import3.createRenderElement(this.renderer,this._el_95,'i',new import3.InlineArray2(2,'class','eva-3-icon-error-circle -eva-3-icon-md -eva-3-tc-red-3'),(null as any));
    this._text_102 = this.renderer.createText(this._el_95,'\n                                    ',(null as any));
    this._text_103 = this.renderer.createText(this._el_93,'\n                                    ',(null as any));
    this._el_104 = import3.createRenderElement(this.renderer,this._el_93,'div',new import3.InlineArray2(2,'class','vcc-header'),(null as any));
    this._text_105 = this.renderer.createText(this._el_104,'\n                                        ',(null as any));
    this._el_106 = import3.createRenderElement(this.renderer,this._el_104,'div',new import3.InlineArray2(2,'class','vcc-status'),(null as any));
    this._text_107 = this.renderer.createText(this._el_106,'\n                                            ',(null as any));
    this._el_108 = import3.createRenderElement(this.renderer,this._el_106,'h4',new import3.InlineArray2(2,'class','-eva-3-tc-green-3 -eva-3-pb-xsm'),(null as any));
    this._text_109 = this.renderer.createText(this._el_108,'',(null as any));
    this._text_110 = this.renderer.createText(this._el_106,'\n                                            ',(null as any));
    this._el_111 = import3.createRenderElement(this.renderer,this._el_106,'h4',new import3.InlineArray2(2,'class','-eva-3-tc-blue-3 -eva-3-pb-xsm'),(null as any));
    this._text_112 = this.renderer.createText(this._el_111,'',(null as any));
    this._text_113 = this.renderer.createText(this._el_106,'\n                                            ',(null as any));
    this._el_114 = import3.createRenderElement(this.renderer,this._el_106,'h4',new import3.InlineArray2(2,'class','-eva-3-tc-green-3 -eva-3-pb-xsm'),(null as any));
    this._text_115 = this.renderer.createText(this._el_114,'',(null as any));
    this._text_116 = this.renderer.createText(this._el_106,'\n                                            ',(null as any));
    this._el_117 = import3.createRenderElement(this.renderer,this._el_106,'h4',new import3.InlineArray2(2,'class','-eva-3-tc-red-3 -eva-3-pb-xsm'),(null as any));
    this._text_118 = this.renderer.createText(this._el_117,'',(null as any));
    this._text_119 = this.renderer.createText(this._el_106,'\n                                        ',(null as any));
    this._text_120 = this.renderer.createText(this._el_104,'\n                                        ',(null as any));
    this._el_121 = import3.createRenderElement(this.renderer,this._el_104,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_122 = this.renderer.createText(this._el_121,'\n                                            ',(null as any));
    this._el_123 = import3.createRenderElement(this.renderer,this._el_121,'div',new import3.InlineArray2(2,'class','vcc-date'),(null as any));
    this._text_124 = this.renderer.createText(this._el_123,'\n                                                ',(null as any));
    this._el_125 = import3.createRenderElement(this.renderer,this._el_123,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_126 = this.renderer.createText(this._el_125,'',(null as any));
    this._el_127 = import3.createRenderElement(this.renderer,this._el_125,'strong',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_128 = this.renderer.createText(this._el_127,'',(null as any));
    this._text_129 = this.renderer.createText(this._el_123,'\n                                            ',(null as any));
    this._text_130 = this.renderer.createText(this._el_121,'\n                                            ',(null as any));
    this._el_131 = import3.createRenderElement(this.renderer,this._el_121,'div',new import3.InlineArray2(2,'class','vcc-company'),(null as any));
    this._text_132 = this.renderer.createText(this._el_131,'\n                                                ',(null as any));
    this._el_133 = import3.createRenderElement(this.renderer,this._el_131,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_134 = this.renderer.createText(this._el_133,'',(null as any));
    this._text_135 = this.renderer.createText(this._el_131,'\n                                            ',(null as any));
    this._text_136 = this.renderer.createText(this._el_121,'\n                                        ',(null as any));
    this._text_137 = this.renderer.createText(this._el_104,'\n                                    ',(null as any));
    this._text_138 = this.renderer.createText(this._el_93,'\n                                ',(null as any));
    this._text_139 = this.renderer.createText(this._el_91,'\n\n                                ',(null as any));
    this._el_140 = import3.createRenderElement(this.renderer,this._el_91,'div',new import3.InlineArray2(2,'class','vcc-main-data'),(null as any));
    this._text_141 = this.renderer.createText(this._el_140,'\n                                    ',(null as any));
    this._el_142 = import3.createRenderElement(this.renderer,this._el_140,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_143 = this.renderer.createText(this._el_142,'\n                                        ',(null as any));
    this._el_144 = import3.createRenderElement(this.renderer,this._el_142,'div',new import3.InlineArray2(2,'class','vcc-number'),(null as any));
    this._text_145 = this.renderer.createText(this._el_144,'\n                                            ',(null as any));
    this._el_146 = import3.createRenderElement(this.renderer,this._el_144,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_147 = this.renderer.createText(this._el_146,'',(null as any));
    this._text_148 = this.renderer.createText(this._el_144,'\n                                        ',(null as any));
    this._text_149 = this.renderer.createText(this._el_142,'\n                                        ',(null as any));
    this._el_150 = import3.createRenderElement(this.renderer,this._el_142,'div',new import3.InlineArray2(2,'class','vcc-name'),(null as any));
    this._text_151 = this.renderer.createText(this._el_150,'\n                                            ',(null as any));
    this._el_152 = import3.createRenderElement(this.renderer,this._el_150,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_153 = this.renderer.createText(this._el_152,'',(null as any));
    this._text_154 = this.renderer.createText(this._el_150,'\n                                        ',(null as any));
    this._text_155 = this.renderer.createText(this._el_142,'\n                                    ',(null as any));
    this._text_156 = this.renderer.createText(this._el_140,'\n                                ',(null as any));
    this._text_157 = this.renderer.createText(this._el_91,'\n\n                                ',(null as any));
    this._el_158 = import3.createRenderElement(this.renderer,this._el_91,'div',new import3.InlineArray2(2,'class','vcc-footer'),(null as any));
    this._text_159 = this.renderer.createText(this._el_158,'\n                                    ',(null as any));
    this._el_160 = import3.createRenderElement(this.renderer,this._el_158,'div',new import3.InlineArray2(2,'class','vcc-footer-data -eva-3-pt-sm'),(null as any));
    this._text_161 = this.renderer.createText(this._el_160,'\n                                        ',(null as any));
    this._el_162 = import3.createRenderElement(this.renderer,this._el_160,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_163 = this.renderer.createText(this._el_162,'\n                                            ',(null as any));
    this._el_164 = import3.createRenderElement(this.renderer,this._el_162,'div',new import3.InlineArray2(2,'class','data-label'),(null as any));
    this._text_165 = this.renderer.createText(this._el_164,'\n                                                ',(null as any));
    this._el_166 = import3.createRenderElement(this.renderer,this._el_164,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_167 = this.renderer.createText(this._el_166,'',(null as any));
    this._text_168 = this.renderer.createText(this._el_164,'\n                                                ',(null as any));
    this._el_169 = import3.createRenderElement(this.renderer,this._el_164,'p',new import3.InlineArray2(2,'class','-eva-3-icon-xsm'),(null as any));
    this._el_170 = import3.createRenderElement(this.renderer,this._el_169,'strong',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_171 = this.renderer.createText(this._el_170,'',(null as any));
    this._text_172 = this.renderer.createText(this._el_164,'\n                                            ',(null as any));
    this._text_173 = this.renderer.createText(this._el_162,'\n                                            ',(null as any));
    this._el_174 = import3.createRenderElement(this.renderer,this._el_162,'div',new import3.InlineArray2(2,'class','data-label -eva-3-pl-md'),(null as any));
    this._text_175 = this.renderer.createText(this._el_174,'\n                                                ',(null as any));
    this._el_176 = import3.createRenderElement(this.renderer,this._el_174,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_177 = this.renderer.createText(this._el_176,'',(null as any));
    this._text_178 = this.renderer.createText(this._el_174,'\n                                                ',(null as any));
    this._el_179 = import3.createRenderElement(this.renderer,this._el_174,'p',new import3.InlineArray2(2,'class','-eva-3-icon-xsm'),(null as any));
    this._el_180 = import3.createRenderElement(this.renderer,this._el_179,'strong',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_181 = this.renderer.createText(this._el_180,'',(null as any));
    this._text_182 = this.renderer.createText(this._el_174,'\n                                            ',(null as any));
    this._text_183 = this.renderer.createText(this._el_162,'\n                                            ',(null as any));
    this._el_184 = import3.createRenderElement(this.renderer,this._el_162,'div',new import3.InlineArray2(2,'class','data-label -eva-3-pl-md'),(null as any));
    this._text_185 = this.renderer.createText(this._el_184,'\n                                                ',(null as any));
    this._el_186 = import3.createRenderElement(this.renderer,this._el_184,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_187 = this.renderer.createText(this._el_186,'',(null as any));
    this._text_188 = this.renderer.createText(this._el_184,'\n                                                ',(null as any));
    this._el_189 = import3.createRenderElement(this.renderer,this._el_184,'p',new import3.InlineArray2(2,'class','-eva-3-icon-xsm'),(null as any));
    this._el_190 = import3.createRenderElement(this.renderer,this._el_189,'strong',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_191 = this.renderer.createText(this._el_190,'',(null as any));
    this._text_192 = this.renderer.createText(this._el_184,'\n                                            ',(null as any));
    this._text_193 = this.renderer.createText(this._el_162,'\n                                            ',(null as any));
    this._el_194 = import3.createRenderElement(this.renderer,this._el_162,'div',new import3.InlineArray2(2,'class','data-label -eva-3-pl-md'),(null as any));
    this._text_195 = this.renderer.createText(this._el_194,'\n                                                ',(null as any));
    this._el_196 = import3.createRenderElement(this.renderer,this._el_194,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_197 = this.renderer.createText(this._el_196,'',(null as any));
    this._text_198 = this.renderer.createText(this._el_194,'\n                                                ',(null as any));
    this._el_199 = import3.createRenderElement(this.renderer,this._el_194,'p',new import3.InlineArray2(2,'class','-eva-3-icon-xsm'),(null as any));
    this._el_200 = import3.createRenderElement(this.renderer,this._el_199,'strong',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_201 = this.renderer.createText(this._el_200,'',(null as any));
    this._text_202 = this.renderer.createText(this._el_194,'\n                                            ',(null as any));
    this._text_203 = this.renderer.createText(this._el_162,'\n                                        ',(null as any));
    this._text_204 = this.renderer.createText(this._el_160,'\n                                        ',(null as any));
    this._el_205 = import3.createRenderElement(this.renderer,this._el_160,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_206 = this.renderer.createText(this._el_205,'\n                                            ',(null as any));
    this._el_207 = import3.createRenderElement(this.renderer,this._el_205,'div',new import3.InlineArray2(2,'class','data-label'),(null as any));
    this._text_208 = this.renderer.createText(this._el_207,'\n                                                ',(null as any));
    this._el_209 = import3.createRenderElement(this.renderer,this._el_207,'p',new import3.InlineArray2(2,'class','eva-3-p'),(null as any));
    this._text_210 = this.renderer.createText(this._el_209,'',(null as any));
    this._el_211 = import3.createRenderElement(this.renderer,this._el_209,'a',new import3.InlineArray4(4,'class','eva-3-link message-link','href','mailto:ast@despegar.com'),(null as any));
    this._text_212 = this.renderer.createText(this._el_211,'',(null as any));
    this._text_213 = this.renderer.createText(this._el_209,'.',(null as any));
    this._text_214 = this.renderer.createText(this._el_207,'\n                                            ',(null as any));
    this._text_215 = this.renderer.createText(this._el_205,'\n                                        ',(null as any));
    this._text_216 = this.renderer.createText(this._el_160,'\n                                    ',(null as any));
    this._text_217 = this.renderer.createText(this._el_158,'\n                                    ',(null as any));
    this._el_218 = import3.createRenderElement(this.renderer,this._el_158,'div',new import3.InlineArray2(2,'class','vcc-type'),(null as any));
    this._text_219 = this.renderer.createText(this._el_218,'\n                                        ',(null as any));
    this._el_220 = import3.createRenderElement(this.renderer,this._el_218,'div',new import3.InlineArray2(2,'class','credit-card-icon'),(null as any));
    this._text_221 = this.renderer.createText(this._el_220,'\n                                            ',(null as any));
    this._anchor_222 = this.renderer.createTemplateAnchor(this._el_220,(null as any));
    this._vc_222 = new import10.ViewContainer(222,220,this,this._anchor_222);
    this._TemplateRef_222_5 = new import14.TemplateRef_(this,222,this._anchor_222);
    this._NgIf_222_6 = new import19.Wrapper_NgIf(this._vc_222.vcRef,this._TemplateRef_222_5);
    this._text_223 = this.renderer.createText(this._el_220,'\n                                        ',(null as any));
    this._text_224 = this.renderer.createText(this._el_218,'\n                                        ',(null as any));
    this._el_225 = import3.createRenderElement(this.renderer,this._el_218,'div',new import3.InlineArray2(2,'class','generic-card'),(null as any));
    this._text_226 = this.renderer.createText(this._el_225,'\n                                            ',(null as any));
    this._el_227 = import3.createRenderElement(this.renderer,this._el_225,'p',new import3.InlineArray2(2,'class','-eva-3-tc-blue-3'),(null as any));
    this._text_228 = this.renderer.createText(this._el_227,'',(null as any));
    this._text_229 = this.renderer.createText(this._el_225,'\n                                        ',(null as any));
    this._text_230 = this.renderer.createText(this._el_218,'\n                                    ',(null as any));
    this._text_231 = this.renderer.createText(this._el_158,'\n                                ',(null as any));
    this._text_232 = this.renderer.createText(this._el_91,'\n                            ',(null as any));
    this._text_233 = this.renderer.createText(this._el_89,'\n                        ',(null as any));
    this._text_234 = this.renderer.createText(this._el_87,'\n                    ',(null as any));
    this._text_235 = this.renderer.createText(this._el_85,'\n                ',(null as any));
    this._text_236 = this.renderer.createText(this._el_83,'\n            ',(null as any));
    this._text_237 = this.renderer.createText(this._el_34,'\n        ',(null as any));
    this._text_238 = this.renderer.createText(this._el_32,'\n    ',(null as any));
    this._text_239 = this.renderer.createText(this._el_19,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_2,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_2));
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_4));
    this._pipe_translate_0 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_3:Function = import3.subscribeToRenderElement(this,this._el_13,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_13));
    var disposable_4:Function = import3.subscribeToRenderElement(this,this._el_19,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_19));
    var disposable_5:Function = import3.subscribeToRenderElement(this,this._el_21,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_21));
    this._pipe_translate_1 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    var disposable_6:Function = import3.subscribeToRenderElement(this,this._el_32,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_32));
    this._pipe_translate_2 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_date_4 = new import20.DatePipe(this.parentView.injectorGet(import23.LOCALE_ID,this.parentIndex));
    this._pipe_date_4_0 = import3.pureProxy2(this._pipe_date_4.transform.bind(this._pipe_date_4));
    this._pipe_translate_5 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_6 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_7 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_8 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_9 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_10 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_11 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_12 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_13 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_14 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_15 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_16 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_17 = new import9.TranslatePipe(this.parentView.injectorGet(import12.TranslateService,this.parentIndex),this.ref);
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._anchor_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._el_27,
      this._text_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._el_32,
      this._text_33,
      this._el_34,
      this._text_35,
      this._el_36,
      this._text_37,
      this._el_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._el_44,
      this._el_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._text_51,
      this._text_52,
      this._el_53,
      this._text_54,
      this._el_55,
      this._text_56,
      this._text_57,
      this._text_58,
      this._text_59,
      this._text_60,
      this._el_61,
      this._text_62,
      this._el_63,
      this._text_64,
      this._el_65,
      this._text_66,
      this._el_67,
      this._text_68,
      this._text_69,
      this._el_70,
      this._text_71,
      this._el_72,
      this._text_73,
      this._el_74,
      this._text_75,
      this._text_76,
      this._text_77,
      this._text_78,
      this._text_79,
      this._text_80,
      this._text_81,
      this._text_82,
      this._el_83,
      this._text_84,
      this._el_85,
      this._text_86,
      this._el_87,
      this._text_88,
      this._el_89,
      this._text_90,
      this._el_91,
      this._text_92,
      this._el_93,
      this._text_94,
      this._el_95,
      this._text_96,
      this._el_97,
      this._text_98,
      this._el_99,
      this._text_100,
      this._el_101,
      this._text_102,
      this._text_103,
      this._el_104,
      this._text_105,
      this._el_106,
      this._text_107,
      this._el_108,
      this._text_109,
      this._text_110,
      this._el_111,
      this._text_112,
      this._text_113,
      this._el_114,
      this._text_115,
      this._text_116,
      this._el_117,
      this._text_118,
      this._text_119,
      this._text_120,
      this._el_121,
      this._text_122,
      this._el_123,
      this._text_124,
      this._el_125,
      this._text_126,
      this._el_127,
      this._text_128,
      this._text_129,
      this._text_130,
      this._el_131,
      this._text_132,
      this._el_133,
      this._text_134,
      this._text_135,
      this._text_136,
      this._text_137,
      this._text_138,
      this._text_139,
      this._el_140,
      this._text_141,
      this._el_142,
      this._text_143,
      this._el_144,
      this._text_145,
      this._el_146,
      this._text_147,
      this._text_148,
      this._text_149,
      this._el_150,
      this._text_151,
      this._el_152,
      this._text_153,
      this._text_154,
      this._text_155,
      this._text_156,
      this._text_157,
      this._el_158,
      this._text_159,
      this._el_160,
      this._text_161,
      this._el_162,
      this._text_163,
      this._el_164,
      this._text_165,
      this._el_166,
      this._text_167,
      this._text_168,
      this._el_169,
      this._el_170,
      this._text_171,
      this._text_172,
      this._text_173,
      this._el_174,
      this._text_175,
      this._el_176,
      this._text_177,
      this._text_178,
      this._el_179,
      this._el_180,
      this._text_181,
      this._text_182,
      this._text_183,
      this._el_184,
      this._text_185,
      this._el_186,
      this._text_187,
      this._text_188,
      this._el_189,
      this._el_190,
      this._text_191,
      this._text_192,
      this._text_193,
      this._el_194,
      this._text_195,
      this._el_196,
      this._text_197,
      this._text_198,
      this._el_199,
      this._el_200,
      this._text_201,
      this._text_202,
      this._text_203,
      this._text_204,
      this._el_205,
      this._text_206,
      this._el_207,
      this._text_208,
      this._el_209,
      this._text_210,
      this._el_211,
      this._text_212,
      this._text_213,
      this._text_214,
      this._text_215,
      this._text_216,
      this._text_217,
      this._el_218,
      this._text_219,
      this._el_220,
      this._text_221,
      this._anchor_222,
      this._text_223,
      this._text_224,
      this._el_225,
      this._text_226,
      this._el_227,
      this._text_228,
      this._text_229,
      this._text_230,
      this._text_231,
      this._text_232,
      this._text_233,
      this._text_234,
      this._text_235,
      this._text_236,
      this._text_237,
      this._text_238,
      this._text_239
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2,
      disposable_3,
      disposable_4,
      disposable_5,
      disposable_6
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import14.TemplateRef) && (15 === requestNodeIndex))) { return this._TemplateRef_15_5; }
    if (((token === import16.NgFor) && (15 === requestNodeIndex))) { return this._NgFor_15_6.context; }
    if (((token === import24.NgClass) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 17)))) { return this._NgClass_0_3.context; }
    if (((token === import14.TemplateRef) && (222 === requestNodeIndex))) { return this._TemplateRef_222_5; }
    if (((token === import25.NgIf) && (222 === requestNodeIndex))) { return this._NgIf_222_6.context; }
    if (((token === import24.NgClass) && ((19 <= requestNodeIndex) && (requestNodeIndex <= 239)))) { return this._NgClass_19_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import11.ValueUnwrapper();
    const currVal_0_0_0:any = 'eva-3-modal';
    this._NgClass_0_3.check_klass(currVal_0_0_0,throwOnChange,false);
    const currVal_0_0_1:any = this._map_248(this.context.getInformationModal().getInformationModal());
    this._NgClass_0_3.check_ngClass(currVal_0_0_1,throwOnChange,false);
    this._NgClass_0_3.ngDoCheck(this,this._el_0,throwOnChange);
    var tmp_15_0_0_0:any = (null as any);
    var tmp_15_0_0_1:any = (null as any);
    const currVal_15_0_0:any = (((tmp_15_0_0_0 = this.context.getInformationModal()) == null)? (null as any): (((tmp_15_0_0_1 = tmp_15_0_0_0.getInformationModalData()) == null)? (null as any): tmp_15_0_0_1.groupText));
    this._NgFor_15_6.check_ngForOf(currVal_15_0_0,throwOnChange,false);
    this._NgFor_15_6.ngDoCheck(this,this._anchor_15,throwOnChange);
    const currVal_19_0_0:any = 'eva-3-modal vcc';
    this._NgClass_19_3.check_klass(currVal_19_0_0,throwOnChange,false);
    const currVal_19_0_1:any = this._map_251(this.context.getInformationModal().showVccModal(),(this.context.getInformationModal().getVcc().status == 'PENDING_ACTIVATION'),(this.context.getInformationModal().getVcc().status != 'PENDING_ACTIVATION'));
    this._NgClass_19_3.check_ngClass(currVal_19_0_1,throwOnChange,false);
    this._NgClass_19_3.ngDoCheck(this,this._el_19,throwOnChange);
    const currVal_222_0_0:boolean = !!this.context.getInformationModal().getVcc().carBrand;
    this._NgIf_222_6.check_ngIf(currVal_222_0_0,throwOnChange,false);
    this._NgIf_222_6.ngDoCheck(this,this._anchor_222,throwOnChange);
    this._vc_15.detectChangesInNestedViews(throwOnChange);
    this._vc_222.detectChangesInNestedViews(throwOnChange);
    valUnwrapper.reset();
    const currVal_249:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform(this.context.getInformationModal().getInformationModalData().title)),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_249,currVal_249))) {
      this.renderer.setText(this._text_9,currVal_249);
      this._expr_249 = currVal_249;
    }
    valUnwrapper.reset();
    const currVal_252:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('bookingDetail.vcc')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_252,currVal_252))) {
      this.renderer.setText(this._text_28,currVal_252);
      this._expr_252 = currVal_252;
    }
    const currVal_254:boolean = !(this.context.getInformationModal().getVcc().status == 'PENDING_ACTIVATION');
    if (import3.checkBinding(throwOnChange,this._expr_254,currVal_254)) {
      this.renderer.setElementProperty(this._el_40,'hidden',currVal_254);
      this._expr_254 = currVal_254;
    }
    valUnwrapper.reset();
    const currVal_255:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('bookingDetail.vcc.pending')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_255,currVal_255))) {
      this.renderer.setText(this._text_50,currVal_255);
      this._expr_255 = currVal_255;
    }
    valUnwrapper.reset();
    const currVal_257:any = import3.inlineInterpolate(2,'\n                                    ',valUnwrapper.unwrap(this._pipe_translate_3.transform('bookingDetail.vcc.pending.description')),'\n                                    ',valUnwrapper.unwrap(import3.castByValue(this._pipe_date_4_0,this._pipe_date_4.transform)(this.context.getInformationModal().getVcc().dropoffDate,'dd-MM-yyyy')),'.\n                                ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_257,currVal_257))) {
      this.renderer.setText(this._text_56,currVal_257);
      this._expr_257 = currVal_257;
    }
    const currVal_261:boolean = !(this.context.getInformationModal().getVcc().status == 'ERROR');
    if (import3.checkBinding(throwOnChange,this._expr_261,currVal_261)) {
      this.renderer.setElementProperty(this._el_61,'hidden',currVal_261);
      this._expr_261 = currVal_261;
    }
    valUnwrapper.reset();
    const currVal_262:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('bookingDetail.vcc.error.description')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_262,currVal_262))) {
      this.renderer.setText(this._text_73,currVal_262);
      this._expr_262 = currVal_262;
    }
    valUnwrapper.reset();
    const currVal_264:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_6.transform('bookingDetail.vcc.contactUs')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_264,currVal_264))) {
      this.renderer.setText(this._text_75,currVal_264);
      this._expr_264 = currVal_264;
    }
    const currVal_266:boolean = !(this.context.getInformationModal().getVcc().status != 'ERROR');
    if (import3.checkBinding(throwOnChange,this._expr_266,currVal_266)) {
      this.renderer.setElementProperty(this._el_83,'hidden',currVal_266);
      this._expr_266 = currVal_266;
    }
    const currVal_267:boolean = !((this.context.getInformationModal().getVcc().status == 'ACTIVE') || (this.context.getInformationModal().getVcc().status == 'CHARGED'));
    if (import3.checkBinding(throwOnChange,this._expr_267,currVal_267)) {
      this.renderer.setElementProperty(this._el_97,'hidden',currVal_267);
      this._expr_267 = currVal_267;
    }
    const currVal_268:boolean = !(this.context.getInformationModal().getVcc().status == 'PENDING_ACTIVATION');
    if (import3.checkBinding(throwOnChange,this._expr_268,currVal_268)) {
      this.renderer.setElementProperty(this._el_99,'hidden',currVal_268);
      this._expr_268 = currVal_268;
    }
    const currVal_269:boolean = !(this.context.getInformationModal().getVcc().status == 'EXPIRED');
    if (import3.checkBinding(throwOnChange,this._expr_269,currVal_269)) {
      this.renderer.setElementProperty(this._el_101,'hidden',currVal_269);
      this._expr_269 = currVal_269;
    }
    const currVal_270:boolean = !(this.context.getInformationModal().getVcc().status == 'ACTIVE');
    if (import3.checkBinding(throwOnChange,this._expr_270,currVal_270)) {
      this.renderer.setElementProperty(this._el_108,'hidden',currVal_270);
      this._expr_270 = currVal_270;
    }
    valUnwrapper.reset();
    const currVal_271:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_7.transform('bookingDetail.vcc.status.active')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_271,currVal_271))) {
      this.renderer.setText(this._text_109,currVal_271);
      this._expr_271 = currVal_271;
    }
    const currVal_273:boolean = !(this.context.getInformationModal().getVcc().status == 'PENDING_ACTIVATION');
    if (import3.checkBinding(throwOnChange,this._expr_273,currVal_273)) {
      this.renderer.setElementProperty(this._el_111,'hidden',currVal_273);
      this._expr_273 = currVal_273;
    }
    valUnwrapper.reset();
    const currVal_274:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_8.transform('bookingDetail.vcc.status.pending')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_274,currVal_274))) {
      this.renderer.setText(this._text_112,currVal_274);
      this._expr_274 = currVal_274;
    }
    const currVal_276:boolean = !(this.context.getInformationModal().getVcc().status == 'CHARGED');
    if (import3.checkBinding(throwOnChange,this._expr_276,currVal_276)) {
      this.renderer.setElementProperty(this._el_114,'hidden',currVal_276);
      this._expr_276 = currVal_276;
    }
    valUnwrapper.reset();
    const currVal_277:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_9.transform('bookingDetail.vcc.status.charged')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_277,currVal_277))) {
      this.renderer.setText(this._text_115,currVal_277);
      this._expr_277 = currVal_277;
    }
    const currVal_279:boolean = !(this.context.getInformationModal().getVcc().status == 'EXPIRED');
    if (import3.checkBinding(throwOnChange,this._expr_279,currVal_279)) {
      this.renderer.setElementProperty(this._el_117,'hidden',currVal_279);
      this._expr_279 = currVal_279;
    }
    valUnwrapper.reset();
    const currVal_280:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_10.transform('bookingDetail.vcc.status.expired')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_280,currVal_280))) {
      this.renderer.setText(this._text_118,currVal_280);
      this._expr_280 = currVal_280;
    }
    const currVal_282:boolean = !((this.context.getInformationModal().getVcc().status == 'ACTIVE') || (this.context.getInformationModal().getVcc().status == 'PENDING_ACTIVATION'));
    if (import3.checkBinding(throwOnChange,this._expr_282,currVal_282)) {
      this.renderer.setElementProperty(this._el_121,'hidden',currVal_282);
      this._expr_282 = currVal_282;
    }
    valUnwrapper.reset();
    const currVal_283:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_11.transform('bookingDetail.vcc.creationDate')),': ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_283,currVal_283))) {
      this.renderer.setText(this._text_126,currVal_283);
      this._expr_283 = currVal_283;
    }
    const currVal_285:any = import3.inlineInterpolate(1,'',this.context.getInformationModal().getVcc().created,'');
    if (import3.checkBinding(throwOnChange,this._expr_285,currVal_285)) {
      this.renderer.setText(this._text_128,currVal_285);
      this._expr_285 = currVal_285;
    }
    const currVal_286:any = import3.inlineInterpolate(1,'',this.context.getInformationModal().getVcc().cardBrand,'');
    if (import3.checkBinding(throwOnChange,this._expr_286,currVal_286)) {
      this.renderer.setText(this._text_134,currVal_286);
      this._expr_286 = currVal_286;
    }
    const currVal_287:boolean = !(((this.context.getInformationModal().getVcc().status == 'ACTIVE') || (this.context.getInformationModal().getVcc().status == 'PENDING_ACTIVATION')) || (this.context.getInformationModal().getVcc().status == 'CHARGED'));
    if (import3.checkBinding(throwOnChange,this._expr_287,currVal_287)) {
      this.renderer.setElementProperty(this._el_142,'hidden',currVal_287);
      this._expr_287 = currVal_287;
    }
    const currVal_288:any = import3.inlineInterpolate(1,'',this.context.getInformationModal().getVcc().cardNumber,'');
    if (import3.checkBinding(throwOnChange,this._expr_288,currVal_288)) {
      this.renderer.setText(this._text_147,currVal_288);
      this._expr_288 = currVal_288;
    }
    const currVal_289:any = import3.inlineInterpolate(1,'',this.context.getInformationModal().getVcc().cardHolder,'');
    if (import3.checkBinding(throwOnChange,this._expr_289,currVal_289)) {
      this.renderer.setText(this._text_153,currVal_289);
      this._expr_289 = currVal_289;
    }
    const currVal_290:boolean = !((this.context.getInformationModal().getVcc().status == 'ACTIVE') || (this.context.getInformationModal().getVcc().status == 'PENDING_ACTIVATION'));
    if (import3.checkBinding(throwOnChange,this._expr_290,currVal_290)) {
      this.renderer.setElementProperty(this._el_162,'hidden',currVal_290);
      this._expr_290 = currVal_290;
    }
    valUnwrapper.reset();
    const currVal_291:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_12.transform('bookingDetail.vcc.activation')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_291,currVal_291))) {
      this.renderer.setText(this._text_167,currVal_291);
      this._expr_291 = currVal_291;
    }
    const currVal_293:any = import3.inlineInterpolate(1,'',this.context.getInformationModal().getVcc().activeFrom,'');
    if (import3.checkBinding(throwOnChange,this._expr_293,currVal_293)) {
      this.renderer.setText(this._text_171,currVal_293);
      this._expr_293 = currVal_293;
    }
    valUnwrapper.reset();
    const currVal_294:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_13.transform('bookingDetail.vcc.expiration')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_294,currVal_294))) {
      this.renderer.setText(this._text_177,currVal_294);
      this._expr_294 = currVal_294;
    }
    const currVal_296:any = import3.inlineInterpolate(2,'',this.context.getInformationModal().getVcc().expirationMonth,'/',this.context.getInformationModal().getVcc().expirationYear,'');
    if (import3.checkBinding(throwOnChange,this._expr_296,currVal_296)) {
      this.renderer.setText(this._text_181,currVal_296);
      this._expr_296 = currVal_296;
    }
    valUnwrapper.reset();
    const currVal_297:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_14.transform('bookingDetail.vcc.code')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_297,currVal_297))) {
      this.renderer.setText(this._text_187,currVal_297);
      this._expr_297 = currVal_297;
    }
    const currVal_299:any = import3.inlineInterpolate(1,'',this.context.getInformationModal().getVcc().securityCode,'');
    if (import3.checkBinding(throwOnChange,this._expr_299,currVal_299)) {
      this.renderer.setText(this._text_191,currVal_299);
      this._expr_299 = currVal_299;
    }
    valUnwrapper.reset();
    const currVal_300:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_15.transform('bookingDetail.vcc.currency')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_300,currVal_300))) {
      this.renderer.setText(this._text_197,currVal_300);
      this._expr_300 = currVal_300;
    }
    const currVal_302:any = import3.inlineInterpolate(1,'',this.context.getInformationModal().getVcc().currency,'');
    if (import3.checkBinding(throwOnChange,this._expr_302,currVal_302)) {
      this.renderer.setText(this._text_201,currVal_302);
      this._expr_302 = currVal_302;
    }
    const currVal_303:boolean = !(this.context.getInformationModal().getVcc().status == 'EXPIRED');
    if (import3.checkBinding(throwOnChange,this._expr_303,currVal_303)) {
      this.renderer.setElementProperty(this._el_205,'hidden',currVal_303);
      this._expr_303 = currVal_303;
    }
    valUnwrapper.reset();
    const currVal_304:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_16.transform('bookingDetail.vcc.error.description')),' ');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_304,currVal_304))) {
      this.renderer.setText(this._text_210,currVal_304);
      this._expr_304 = currVal_304;
    }
    valUnwrapper.reset();
    const currVal_306:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_17.transform('bookingDetail.vcc.contactUs')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_306,currVal_306))) {
      this.renderer.setText(this._text_212,currVal_306);
      this._expr_306 = currVal_306;
    }
    const currVal_308:boolean = !((((this.context.getInformationModal().getVcc().cardBrand == 'AX') || (this.context.getInformationModal().getVcc().cardBrand == 'CA')) || (this.context.getInformationModal().getVcc().cardBrand == 'CL')) || (this.context.getInformationModal().getVcc().cardBrand == 'VI'));
    if (import3.checkBinding(throwOnChange,this._expr_308,currVal_308)) {
      this.renderer.setElementProperty(this._el_220,'hidden',currVal_308);
      this._expr_308 = currVal_308;
    }
    const currVal_309:boolean = !((((this.context.getInformationModal().getVcc().cardBrand != 'AX') && (this.context.getInformationModal().getVcc().cardBrand != 'CA')) && (this.context.getInformationModal().getVcc().cardBrand != 'CL')) && (this.context.getInformationModal().getVcc().cardBrand != 'VI'));
    if (import3.checkBinding(throwOnChange,this._expr_309,currVal_309)) {
      this.renderer.setElementProperty(this._el_225,'hidden',currVal_309);
      this._expr_309 = currVal_309;
    }
    const currVal_310:any = import3.inlineInterpolate(1,'',this.context.getInformationModal().getVcc().cardBrand,'');
    if (import3.checkBinding(throwOnChange,this._expr_310,currVal_310)) {
      this.renderer.setText(this._text_228,currVal_310);
      this._expr_310 = currVal_310;
    }
  }
  destroyInternal():void {
    this._vc_15.destroyNestedViews();
    this._vc_222.destroyNestedViews();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
    this._pipe_translate_9.ngOnDestroy();
    this._pipe_translate_10.ngOnDestroy();
    this._pipe_translate_11.ngOnDestroy();
    this._pipe_translate_12.ngOnDestroy();
    this._pipe_translate_13.ngOnDestroy();
    this._pipe_translate_14.ngOnDestroy();
    this._pipe_translate_15.ngOnDestroy();
    this._pipe_translate_16.ngOnDestroy();
    this._pipe_translate_17.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 15)) { return new View_InformationModalComponent1(this.viewUtils,this,15,this._anchor_15,this._vc_15); }
    if ((nodeIndex == 222)) { return new View_InformationModalComponent3(this.viewUtils,this,222,this._anchor_222,this._vc_222); }
    return (null as any);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.context.getInformationModal().hideInformationModal()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_2(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.context.getInformationModal().hideInformationModal()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.context.getInformationModal().hideInformationModal()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_13(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>$event.stopPropagation()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_19(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.context.getInformationModal().hideVcc()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_21(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      $event.stopPropagation();
      const pd_sub_0:any = ((<any>this.context.getInformationModal().hideVcc()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
  handleEvent_32(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>$event.stopPropagation()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/root/information-modal/information-modal.component.ngfactory.ts